import { Inject, Injectable } from '@angular/core';
import { QueryService } from 'src/app/core/services/query.service';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';
import { CATALOG_SECTION_ENDPOINT, CATALOG_SECTION_QUERY_SERVICE_INSTANCE } from '../filiere.config';
import { CrudService } from 'src/app/core/services/crud.service';
import { IPageEvent } from 'src/app/core/models/paginator.model';

@Injectable({
  providedIn: 'root'
})
export class CatalogSectionService extends CrudService<any>{

  constructor(
      @Inject(CATALOG_SECTION_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<any>,
      public readonly apiService: ApiService,
      protected  override readonly snackbar : SnackbarService
    ) {
      super(CATALOG_SECTION_ENDPOINT, apiService, snackbar);
    }

    getAllFiltered(parameter : IPageEvent, searchData?:any, filters?: Record<string, any>){
            const stringSearch = searchData || ''
            let queryParams: string[] = [];
            if(filters){
              Object.keys(filters).forEach(key => {
        
                if (filters[key]) {
                  let filterValue = '';
                  if(key.includes('_from')){
                    filterValue = `${key.split('_from')[0]}||gte||${filters[key]}`;
                  }else if(key.includes('_to')){
                    filterValue = `${key.split('_to')[0]}||lte||${filters[key]}`;
                  }else{
                    if(filters[key] instanceof Object){
                      Object.keys(filters[key]).forEach(k => {
                        if (filters[key][k]){
                          filterValue = `${key}.${k}||eq||${filters[key][k]}`
                        }
                      })
                    }else{
                      filterValue = `${key}||eq||${filters[key]}`
                    }
                  }
                  queryParams.push(`filter=${encodeURIComponent(filterValue)}`);
                }
              });
            }
            queryParams.push(`page=${parameter.pageIndex}`);
            queryParams.push(`limit=${parameter.pageSize}`);
            if(searchData) queryParams.push(`search=${stringSearch}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.apiService.get(CATALOG_SECTION_ENDPOINT + queryString);
        
          }

          massiveDelete(ids: number[]) : any{ 
                return this.apiService.delete(CATALOG_SECTION_ENDPOINT, 0, false, {ids: ids} );
              }

}

